export const addResultsWater = {
    namespaced: true,

    state: {
        groupFilter: {
            selectedCrewId: null,
            selectedAlternativeUserId: null
        }
    }
};
